import { tenderStatus } from '@/utils/locale'
import dateUtil from '@/utils/dateUtil'
import lodash from 'lodash'

export function getIssueDateArr (tender) {
  const tenderHistories = [...lodash.get(tender, 'histories', [])].sort(dateUtil.dateSortFunc('createdAt', true))
  return tenderHistories.reduce((pre, cur) => {
    if (cur.status && (cur.status.indexOf(tenderStatus.ISSUED) >= 0)) {
      pre.push({date: dateUtil.formatDate(cur.createdAt, 'MMM dd')})
    }
    return pre
  }, [])
}

export default {
  computed: {
    issueDateArr () {
      return getIssueDateArr(this.currentTender)
    },
  },
}
